import "../App.css";
import crypt from "crypto-js";

const verifyDecryptedPlaintext = "A happy little plaintext test string";
const keysTest = require("../keyTest.json");

function decrypt(cipher, key) {
    return crypt.AES.decrypt(cipher, key);
}

export function getFile(path) {
    return require("../pages/media" + path);
}

export function decryptFile(fileJSON, key) {
    let decrypted = decrypt(fileJSON.data, key).toString(crypt.enc.Base64);
    return decrypted;
}

export function decryptPage(page, key) {
    let decrypted = decrypt(page.content, key).toString(crypt.enc.Utf8);
    return decrypted;
}

export function callFetchResource({ src }, globalState) {
    let fileJSON = getFile(src);
    if (fileJSON.access !== "public") {
        let decrypted = decryptFile(fileJSON, globalState.keyring[fileJSON.access] || globalState.key);
        if (decrypted) {
            return "data:" + fileJSON.mediaType + ";base64," + decrypted;
        } else {
            return "error: Failed to decrypt"
        }
    } else {
        return "data:" + fileJSON.mediaType + ";base64," + fileJSON.data;
    }
}

export function verifyDecrypted(page, key) {
    try {
        if (crypt.AES.decrypt(keysTest[page.access], key).toString(crypt.enc.Utf8) === verifyDecryptedPlaintext) {
            return true;
        } else {
            return false;
        }
    } catch(e) {
        return false;
    }
}

const cipherModule = {
    decryptFile: decryptFile,
    decryptPage: decryptPage,
    callFetchResource: callFetchResource,
    verifyKey: verifyDecrypted
}
export default cipherModule;